import { EventEmitter, Injectable } from '@angular/core';
import {LoadServiceInterface} from "../../interfaces/load-service.interface";

@Injectable(
    {
        providedIn: 'root',
    }
)
export class LoadService implements LoadServiceInterface {
    load = false;
    changeLoad: EventEmitter<boolean> = new EventEmitter();

    enableLoad() {
        this.load = true;
        this.changeLoad.emit(true);
    }

    disableLoad() {
        setTimeout(() => {
            this.load = false;
            this.changeLoad.emit(false);
        }, 250);
    }
}
